import React from 'react';
import { Card, Button, Badge, Row, Col } from 'react-bootstrap';
import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa';

const projects = [
  {
    title: 'Blingify',
    description:
      'Developed a fast, dynamic e-commerce frontend with Next.js and React. Integrated APIs for real-time product data and optimized UX with server-side rendering, dynamic routing, and image optimization. Reduced page load and FCP by 30-40%.',
    tags: ['Next.js', 'React', 'Tailwind CSS'],
    image: 'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=600&q=80',
    github: 'https://github.com/codeByUtkarsh/blingify',
    demo: 'https://blingify.vercel.app/',
  },
  {
    title: 'Recipe Sharing App',
    description:
      'Built scalable backend with Spring Boot and MySQL. Designed efficient relational schema, REST APIs (CRUD), and robust review system. Achieved 99.9% uptime, <300ms response, and boosted user engagement by 35%.',
    tags: ['Spring Boot', 'Java', 'MySQL'],
    image: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=600&q=80',
    github: 'https://github.com/codeByUtkarsh/Recipe-Sharing-App-Backend',
    demo: '',
  },
];

const Projects = () => (
  <div className="container section">
    <h2 className="mb-5 fw-bold text-center projects-heading">Projects</h2>
    <Row className="g-4 justify-content-center">
      {projects.map((project, idx) => (
        <Col xs={12} md={6} lg={5} key={project.title} className="d-flex align-items-stretch">
          <Card className="project-card shadow-sm border-0 w-100 h-100">
            <div className="project-img-wrapper">
              <Card.Img
                variant="top"
                src={project.image}
                alt={project.title}
                className="project-img"
              />
            </div>
            <Card.Body className="d-flex flex-column">
              <h5 className="fw-bold mb-2 project-title">{project.title}</h5>
              <div className="mb-3">
                {project.tags.map(tag => (
                  <Badge key={tag} bg="secondary" className="me-2 mb-1 project-tag">
                    {tag}
                  </Badge>
                ))}
              </div>
              <Card.Text className="mb-3 project-desc">
                {project.description}
              </Card.Text>
              <div className="mt-auto d-flex gap-2">
                {project.demo && (
                  <Button
                    variant="outline-primary"
                    href={project.demo}
                    target="_blank"
                    className="d-flex align-items-center gap-2 project-btn"
                  >
                    <FaExternalLinkAlt /> Live Demo
                  </Button>
                )}
                <Button
                  variant="outline-dark"
                  href={project.github}
                  target="_blank"
                  className="d-flex align-items-center gap-2 project-btn"
                >
                  <FaGithub /> GitHub
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  </div>
);

export default Projects;
